export class EnvProviderService {

  environment: any = {};

  constructor() { }
}
